import { Modal, ModalId } from "../../../../../features/ui"

type Props = {
    createMode?: boolean
    onSubmit?: () => void
    onCancel?: () => void
}

export const CustomerWarningModal = (props: Props) => {
    const { createMode = true, onSubmit, onCancel } = props

    return (
        <Modal
            modalId={ModalId.CUSTOMER_WARNING}
            title={`Datos de ${createMode ? 'Nuevo ' : ''}Cliente`}
            submitLabel={`Omitir y ${createMode ? 'Crear' : 'Guardar'} Cliente`}
            cancelLabel="Agregar Datos"
            widthSize="s"
            onSubmit={onSubmit}
            onCancel={onCancel}
        >
            <p>{`Se sugiere agregar un teléfono o un mail de contacto al ${createMode ? 'nuevo ' : ''}cliente.`}</p>
        </Modal>
    )
}
